/* YUYA STUDIO wishlist — localStorage based, no login required. */
(function () {
  var KEY = 'yuya_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateBadges();
    updateButtons();
    document.dispatchEvent(new CustomEvent('yuya:wishlist-change'));
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function toggle(handle) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx >= 0) list.splice(idx, 1);
    else list.push({ handle: handle, added: Date.now() });
    write(list);
  }

  function updateBadges() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-wishlist-toggle'));
  });

  function money(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function cardHTML(p) {
    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var img2 = p.images && p.images[1];
    var media = img
      ? '<img class="yuya-card__img yuya-card__img--primary" src="' + img + '&width=600" alt="' + p.title + '" loading="lazy">'
        + (img2 ? '<img class="yuya-card__img yuya-card__img--hover" src="' + img2 + '&width=600" alt="" loading="lazy">' : '')
      : '';
    var sold = p.available ? '' : '<span class="yuya-card__soldout">SOLD OUT</span>';
    return '<li class="yuya-card">'
      + '<button class="yuya-wish" data-wishlist-toggle="' + p.handle + '" aria-label="ウィッシュリストから削除" aria-pressed="true">' + heartSvg() + '</button>'
      + '<a href="/products/' + p.handle + '" class="yuya-card__link">'
      + '<div class="yuya-card__media">' + media + sold + '</div>'
      + '<div class="yuya-card__info"><p class="yuya-card__name">' + p.title + '</p>'
      + '<p class="yuya-card__price">' + money(p.price) + '</p></div>'
      + '</a></li>';
  }

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (list.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    // newest first
    list.sort(function (a, b) { return (b.added || 0) - (a.added || 0); });
    Promise.all(list.map(function (i) {
      return fetch('/products/' + i.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(cardHTML).join('');
      grid.innerHTML = html || '';
      if (!html && empty) empty.hidden = false;
      updateButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    updateButtons();
    renderWishlistPage();
  });
  // re-render wishlist page live when items are removed there
  document.addEventListener('yuya:wishlist-change', function () {
    if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
  });
})();
